import { useEffect, useRef, useState } from 'react'

import { formatDate } from 'pages/account/savings/info/deposit-active/components/transactions/utils'

import cn from 'classnames'
import Calendar from 'react-calendar'

import ArrowIcon from 'images/icon-arrow.svg'

import useOnClickOutside from '../../../../../hooks/use-on-click-outside'

import Cancel from './assets/cancel.svg'
import CancelHover from './assets/cancel-hover.svg'

import styles from './styles.module.scss'
import { useTranslation } from 'utils/use-translation'

export default function DatePicker({
  className = null,
  startDate,
  endDate,
  showCalendar,
  setShowCalendar,
  handleChangeCalendar,
  handleClearCalendar,
}) {
  const { t } = useTranslation()

  const [isHoveringCancel, setIsHoveringCancel] = useState(false)
  const [screenWidth, setScreenWidth] = useState<number>(0)
  const ref = useRef(null)

  useOnClickOutside(ref, () => setShowCalendar(false))

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setScreenWidth(window.innerWidth)
    }
  }, [])

  return (
    <>
      <div className={cn(styles.selectButton, className)}>
        <div className={styles.select} onClick={() => setShowCalendar(true)}>
          {startDate && endDate ? (
            <div className={styles.selectedDates}>
              {formatDate(startDate)} &ndash; {formatDate(endDate)}
            </div>
          ) : (
            <p>{t('select_period')}</p>
          )}
          <img className={styles.arrow} alt="Arrow" src={ArrowIcon} />
        </div>

        {showCalendar && (
          <div ref={ref} className={styles.calendar} onClick={(e) => e.stopPropagation()}>
            <Calendar
              onChange={handleChangeCalendar}
              value={[startDate || new Date(), endDate || new Date()]}
              showDoubleView={screenWidth > 765}
              selectRange={true}
            />
          </div>
        )}

        {startDate && endDate && (
          <img
            alt="Clear filter"
            src={isHoveringCancel ? CancelHover : Cancel}
            onClick={handleClearCalendar}
            className={cn(styles.clearFilter, (endDate || startDate) && styles.clearFilterActive)}
            onMouseEnter={() => setIsHoveringCancel(true)}
            onMouseLeave={() => setIsHoveringCancel(false)}
          />
        )}
      </div>
    </>
  )
}
